'use strict';

module.exports = 'ipfs-pubsub-direct-channel/v1';